import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-caution',
  templateUrl: './svg-caution.component.html',
  styleUrls: ['./svg-caution.component.css']
})
export class SvgCautionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
